import { useFeatureFlagStore } from "~/hooks/useFeatureFlags";
import { useRemoteFeatureFlags } from "~/hooks/useRemoteFeatureFlags";
import { DiscoveryV2Search } from "./v2/DiscoveryV2Search";
import { DiscoveryV3Search } from "./v3/DiscoveryV3Search";

import { useDiscoverySearchUrlState } from "./components/marketSearchState.shared";

export const DiscoverySearchRedirect = () => {
  useDiscoverySearchUrlState();
  const forceMarketSearchRevamp = useFeatureFlagStore((store) =>
    store.isActive("DISCOVERY_SEARCH_REVAMP"),
  );
  const isMarketSearchRevampFeatureFlagEnabled =
    useRemoteFeatureFlags().isActive("marketSearchRevamp");

  if (forceMarketSearchRevamp || isMarketSearchRevampFeatureFlagEnabled) {
    return <DiscoveryV3Search />;
  }

  return <DiscoveryV2Search />;
};
